import { Snapshot } from '@ember-data/store';
import pick from 'lodash-es/pick';
import { underscore } from '@ember/string';
import ApplicationSerializer from 'uplisting-frontend/serializers/application';

const CREATE_ATTRIBUTES = [
  'label',
  'section',
  'position',
  'required',
  'requires_photo',
];
const UPDATE_ATTRIBUTES = [
  'label',
  'section',
  'position',
  'required',
  'requires_photo',
  'note',
  'completed',
];

export default class TaskChecklistItemSerializer extends ApplicationSerializer {
  serialize(snapshot: Snapshot, options: object) {
    const data = super.serialize(snapshot, options);

    if (snapshot.id) {
      const changed = Object.keys(snapshot.changedAttributes()).map((key) =>
        underscore(key),
      );

      // @ts-expect-error - we have no typings for the json api
      data.data.attributes = pick(
        // @ts-expect-error - we have no typings for the json api
        data.data.attributes,
        UPDATE_ATTRIBUTES.filter((key) => changed.includes(key)),
      );
      // @ts-expect-error - we have no typings for the json api
      delete data.data.relationships;
    } else {
      // @ts-expect-error - we have no typings for the json api
      data.data.attributes = pick(data.data.attributes, CREATE_ATTRIBUTES);

      // @ts-expect-error - we have no typings for the json api
      data.data.relationships = {
        task: { data: { id: snapshot.attr('taskId') } },
      };
    }

    return data;
  }
}

declare module 'ember-data/types/registries/serializer' {
  interface SerializerRegistry {
    'task-checklist-item': TaskChecklistItemSerializer;
  }
}
